const routes = [
  {
    path: '/pages/sdkpage/index',
    name: 'sdkpage',
    meta: {
      title: "官方社区",
      keepAlive: true
    },
    component: () => import('../pages/sdkpage/index.vue')
  },
  {
    path: '/pages/index/index',
    name: 'index',
    meta: {
      title: "首页",
      keepAlive: true
    },
    component: () => import('../pages/index/index.vue')
  },
  {
    path: '/pages/index/verification/verification',
    name: 'verification',
    meta: {
      title: '验证码登录'
    },
    component: () => import('../pages/index/verification/verification.vue')
  },
  {
    path: '/pages/index/gamedetail/gamedetail',
    name: 'gamedetail',
    meta: {
      title: "游戏详情",
      keepAlive: true
    },
    component: () => import('../pages/index/gameDetail/gameDetail.vue')
  },
  {
    path: '/pages/index/gameNotice/gameNotice',
    name: 'gameNotice',
    meta: {
      title: "游戏公告"
    },
    component: () => import('../pages/index/gameNotice/gameNotice.vue')
  },
  {
    path: '/pages/index/gameNotice/gameNoticeDetail',
    name: 'gameNoticeDetail',
    meta: {
      title: "游戏公告详情"
    },
    component: () => import('../pages/index/gameNotice/gameNoticeDetail.vue')
  },
  {
    path: '/pages/index/searchView/search',
    name: 'searchView',
    meta: {
      title: "游戏搜索",
      keepAlive: true
    },
    component: () => import('../pages/index/searchView/search.vue')
  },
  {
    path: '/pages/index/gift/gift',
    name: 'gift',
    meta: {
      title: "游戏礼包"
    },
    component: () => import('../pages/index/gameGift/gameGift.vue')
  },
  {
    path: '/pages/index/gift/giftDetail',
    name: 'giftDetail',
    meta: {
      title: "礼包详情"
    },
    component: () => import('../pages/index/gameGift/giftDetail.vue')
  },
  {
    path: '/pages/index/gamedetail/gameMessage',
    name: 'gameMessage',
    meta: {
      title: "游戏信息"
    },
    component: () => import('../pages/index/gameDetail/gameMessage.vue')
  },
  {
    path: '/pages/index/RoleList/RoleList',
    name: 'RoleList',
    meta: {
      title: "角色列表"
    },
    component: () => import('../pages/index/RoleList/RoleList.vue')
  },
  {
    path: '/pages/member/member',
    name: 'member',
    meta: {
      title: "会员中心",
      keepAlive: true
    },
    component: () => import('../pages/member/member.vue')
  },
  {
    path: '/pages/member/memberExplain',
    name: 'memberExplain',
    meta: {
      title: "会员规则",
      keepAlive: false
    },
    component: () => import('../pages/member/memberExplain.vue')
  },
  {
    path: '/pages/index/linktap/index',
    name: 'linktap',
    meta: {
      title: "浏览器下载"
    },
    component: () => import('../pages/index/linktap/index.vue')
  },
  {
    path: '/pages/index/linktap/kfQrcode',
    name: 'kfQrcode',
    meta: {
      title: "联系客服"
    },
    component: () => import('../pages/index/linktap/kfQrcode.vue')
  },
  {
    path: '/pages/member/benefitIntro',
    name: 'benefitIntro',
    meta: {
      title: "权益介绍",
      keepAlive: false
    },
    component: () => import('../pages/member/benefitIntro.vue')
  },
  {
    path: '/pages/member/member-gv/privilege',
    name: 'memberGvPrivilege',
    meta: {
      title: '高V福利',
      keepAlive: false,
      isLogin: true
    },
    component: () => import('../pages/member/member-gv/privilege.vue')
  }
]

export default routes
